/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var WebformSelect = function () {
  function WebformSelect($) {
    _classCallCheck(this, WebformSelect);
    $('#edit-condition-or-visit-reason').select2({
      theme: 'classic'
    });
    var condition = window.sessionStorage.getItem('recent-condition');
    if (condition) {
      var conditionId = $('#edit-condition-or-visit-reason option').filter(function () {
        return $('#edit-condition-or-visit-reason option').html() === condition;
      }).val();
      $('#edit-condition-or-visit-reason').val(conditionId);
      $('#edit-condition-or-visit-reason').trigger('change');
    }
    WebformSelect.createListeners($);
  }
  return _createClass(WebformSelect, null, [{
    key: "addButtonClickEvent",
    value: function addButtonClickEvent($) {
      WebformSelect.removeErrorMessages($);
      setTimeout(function () {
        var radioGroup = document.querySelectorAll('.js-form-type-radio');
        if (radioGroup[0].classList.contains('error')) {
          var hasErrorMessage = document.querySelector('.js-form-type-radio strong');
          if (!hasErrorMessage) {
            WebformSelect.updateErrorBorder(radioGroup);
          }
        } else {
          _toConsumableArray(radioGroup).every(function (item) {
            return _toConsumableArray(item.children).every(function (child) {
              if (child.classList.contains('error')) {
                WebformSelect.updateErrorBorder(radioGroup);
                return false;
              }
              return true;
            });
          });
        }
      }, 10);
    }
  }, {
    key: "setUserDetails",
    value: function setUserDetails($) {
      var emailInput = $('#edit-email-address').val();
      var conditionInput = $('#select2-edit-condition-or-visit-reason-container').text();
      sessionStorage.setItem('email', emailInput);
      sessionStorage.setItem('recent-condition', conditionInput);
    }
  }, {
    key: "updateErrorBorder",
    value: function updateErrorBorder(radioButtons) {
      radioButtons.forEach(function (element) {
        element.classList.toggle('error');
      });
    }
  }, {
    key: "removeErrorMessages",
    value: function removeErrorMessages($) {
      $('.form-item--error-message').remove();
    }
  }, {
    key: "createListeners",
    value: function createListeners($) {
      var _this = this;
      $(document).ready(function () {
        $('#edit-submit').click(function () {
          _this.addButtonClickEvent($);
          _this.setUserDetails($);
        });
      });
    }
  }]);
}();
export { WebformSelect as default };
(function ($) {
  var isWebformPage = document.querySelectorAll('.webform-wrapper')[0];
  if (isWebformPage) {
    var webformSelect = new WebformSelect($);
  }
})(jQuery, Drupal);